import UUID from "pure-uuid";

export const generateUuid = () => 
    new UUID(4).format();

    